import type { EnumLabelType, EnumValueType } from '../../EnumUtils'
import { EnumUtils } from '../../EnumUtils'

/**
 * 售后状态常量
 */
export const AfterSalesStatusConstants = {
  PENDING_REVIEW: {
    value: 1,
    label: '待审核',
  },
  PENDING_ORDER: {
    value: 2,
    label: '待下单',
  },
  PENDING_CONFIRM: {
    value: 3,
    label: '待确认订单',
  },
  PENDING_PICKUP: {
    value: 4,
    label: '待拿货',
  },
  REVIEW_REJECTED: {
    value: 5,
    label: '审核未通过',
  },
  PENDING_REFUND: {
    value: 6,
    label: '待退款',
  },
  REFUNDING: {
    value: 7,
    label: '退款中',
  },
  COMPLETED: {
    value: 8,
    label: '已完成',
  },
  CLOSED: {
    value: 9,
    label: '已关闭',
  },
  S_AUDIT_PASS: {
    value: 10,
    label: 'S端申请并通过',
  },
} as const

export type AfterSalesStatusValue = EnumValueType<typeof AfterSalesStatusConstants>
export type AfterSalesStatusLabel = EnumLabelType<typeof AfterSalesStatusConstants>
export const afterSalesStatusEnumUtils = new EnumUtils<AfterSalesStatusValue>(AfterSalesStatusConstants)

export default afterSalesStatusEnumUtils
